/*
* 相關法條連結：
* - 財政部：執行業務所得如何辦理扣繳（111-04-29）：https://www.etax.nat.gov.tw/etwmain/tax-info/understanding/tax-q-and-a/national/individual-income-tax/withheld-rule/rule/a7BB6R9
* - 財政部：1102 非中華民國境內居住之個人如何課徵綜合所得稅？：https://www.etax.nat.gov.tw/etwmain/tax-info/understanding/tax-q-and-a/national/individual-income-tax/taxation-scope/filing/WAK0jZr
* - 財政部：各類所得的扣繳率各多少（114-01-09）：https://www.etax.nat.gov.tw/etwmain/tax-info/innotative-tax-e-reference/withheld/regulation/Prj8q2V
* - 健保局：補充保險費計算公式（110.01.01）：https://www.nhi.gov.tw/ch/cp-4516-74b0f-2613-1.html
* - 勞動部：歷年最低工資/基本工資調整(2025-12-04)：https://www.mol.gov.tw/1607/28162/28166/28180/70460/76761/76833/post
* 更新日期：2026-01-10
*/

// 所得稅額起扣點（居住者）
export const TAX_AMT_THRESHOLD = 2000;

// 所得起扣點（非居住者）
export const NOT_RESIDENT_AMT_TAX_THRESHOLD = 5000;

// 薪資所得起扣點
export const SALARY_TAX_THRESHOLD = 90501;

// 基本工資(最低薪資)
export const MINIMUM_WAGE = 29500;

// 二代健保所得起扣點
export const GEN2_THRESHOLD = 20000;

// 二代健保稅率
export const GEN2_RATIO = 2.11;

/**
 * 取得所得扣繳金額
 */
export function getTaxAmtInfo(incomeType, amtTwd, isResident) {
    // 1:9A 執行業務所得
    // 2:9B 稿費
    // 4:51 租金收入
    // 5:91 競技、競賽及機會中獎之獎金
    // 6:53 權利金
    if (incomeType === 1 || incomeType === 2 || incomeType === 4 || incomeType === 5 || incomeType === 6) {
        // 非居住者（外國人該年在台未滿183天）超過 5,000 應扣繳 20%
        if (!isResident) {
            // 稅額超過所得稅起扣點
            if (amtTwd > NOT_RESIDENT_AMT_TAX_THRESHOLD) {
                return {
                    ratio: 20,
                    amt: Math.round(amtTwd * 0.2),
                };
            }
            return { ratio: 0, amt: 0 };
        }
        // 居住者（本國人、外國人該年在台已滿183天）10%
        if (isResident) {
            if (Math.floor(amtTwd * 0.1) > TAX_AMT_THRESHOLD) {
                return {
                    ratio: 10,
                    amt: Math.round(amtTwd * 0.1),
                };
            }
        }
    }

    // 3:50 薪資所得
    if (incomeType === 3) {
        // 非居住者（外國人該年在台未滿183天）
        if (!isResident) {
            // 全月薪資給付總額在行政院核定每月基本工資1.5倍以下者6%
            // 否則 18%
            if (amtTwd <= MINIMUM_WAGE * 1.5) {
                return {
                    ratio: 6,
                    amt: Math.round(amtTwd * 0.06),
                };
            }
            return {
                ratio: 18,
                amt: Math.round(amtTwd * 0.18),
            };
        }
        // 居住者（本國人、外國人該年在台已滿183天）5%
        // 給付金額達薪資所得起扣點
        if (isResident) {
            if (amtTwd >= SALARY_TAX_THRESHOLD) {
                return {
                    ratio: 5,
                    amt: Math.round(amtTwd * 0.05),
                };
            }
        }
    }

    // 其他
    return { ratio: 0, amt: 0, msg: null };
}

/**
 * 取得代扣二代健保補充保費金額
 */
export function getGen2AmtInfo(incomeType, amtTwd, hasUnionInsurance) {
    // 1:9A 執行業務所得
    // 2:9B 稿費
    // 4:51 租金收入
    if (incomeType === 1 || incomeType === 2 || incomeType === 4) {
        // 有投保職業工會（免扣）
        if (hasUnionInsurance) return { ratio: 0, amt: 0 };
        // 給付金額超過二代健保起扣點
        if (amtTwd >= GEN2_THRESHOLD) {
            return {
                ratio: GEN2_RATIO,
                amt: Math.round(amtTwd * (GEN2_RATIO / 100).toFixed(4)),
            };
        }
    }
    // 3:50 薪資所得
    if (incomeType === 3) {
        // 有投保職業工會（免扣）
        if (hasUnionInsurance) return { ratio: 0, amt: 0 };
        // 超過當年度基本工資
        if (amtTwd >= MINIMUM_WAGE) {
            return {
                ratio: GEN2_RATIO,
                amt: Math.round(amtTwd * (GEN2_RATIO / 100).toFixed(4)),
            };
        }
        return { ratio: 0, amt: 0, msg: null };
    }
    // 其他
    return { ratio: 0, amt: 0, msg: null };
}
